<ion-row class="m-10">
  <ion-col size="4">
    <div class=" mb-5 ml-20 font_bold fs-18 fs_16ForMobile">Candidate Form </div>
  </ion-col>
  <ion-col size="8" class="text-right">
    <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
  </ion-col>
</ion-row>


<mat-dialog-content>
  <div class="tabs-container " id="elcmCandidate" #formContainer>
    <form [formGroup]="employeeForm">
      <div class="cardBox ">
        <div class="cardBoxHeading font_medium">
          <ion-row class="pl-5">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="font_bold ">Candidate Details</div>
            </ion-col>
          </ion-row>
        </div>

        <div class="font_medium ml-10 mr-10">
          <ion-row class="responsive-form m-10 p-20">
            <!-- Salutation -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Salutation <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">

                <mat-select placeholder="Select Salutation" formControlName="salutation">
                  <mat-option value="Mr.">Mr.</mat-option>
                  <mat-option value="Ms.">Ms.</mat-option>
                  <mat-option value="Mrs.">Mrs.</mat-option>
                  <mat-option value="Dr.">Dr.</mat-option>
                </mat-select>
                <mat-error *ngIf="hasError('salutation', 'required')">solutation is
                  required</mat-error>
              </mat-form-field>
            </ion-col>

            <!-- First Name -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">First Name <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter First Name" formControlName="firstName" />
                <mat-error *ngIf="employeeForm.get('firstName')?.hasError('required')">
                  First Name is required
                </mat-error>

                <mat-error *ngIf="employeeForm.get('firstName')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('firstName')?.hasError('pattern') &&! employeeForm.get('firstName')?.hasError('maxlength')">
                  Invalid characters used
                </mat-error>
                <mat-error *ngIf="
    employeeForm.get('firstName')?.hasError('whitespace') &&
    !employeeForm.get('firstName')?.hasError('required')
  ">
                  First Name cannot be just spaces
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Last Name -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last Name <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Last Name" formControlName="lastName" />
                <mat-error *ngIf="employeeForm.get('lastName')?.hasError('required')">
                  Last Name is required
                </mat-error>



                <mat-error *ngIf="employeeForm.get('lastName')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>

                <mat-error
                  *ngIf="employeeForm.get('lastName')?.hasError('pattern')&& !employeeForm.get('lastName')?.hasError('maxlength')">
                  Invalid characters used
                </mat-error>

                <mat-error *ngIf="
        employeeForm.get('lastName')?.hasError('whitespace') &&
        !employeeForm.get('lastName')?.hasError('required')
      ">
                  Last Name cannot be just spaces
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Personal Email<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter email" formControlName="personalEmail" />
                <mat-error *ngIf="hasError('personalEmail', 'required')">personal email is
                  required</mat-error>
                <mat-error *ngIf="employeeForm.get('personalEmail')?.hasError('strictEmail')">
                  Enter a valid email address
                </mat-error>

              </mat-form-field>
            </ion-col>
            <!-- Gender -->
            <ion-col size="12" size-md="3">
              <!-- <label class="formLabelRegularfs16 mb-5">Gender <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">

       
                <input matInput type="text" placeholder="Select Gender" formControlName="genders"    />
                <mat-error *ngIf="hasError('genders', 'required')">genders is
                  required</mat-error>
              </mat-form-field> -->
              <ion-col size="12" size-md="3">
                <label class="formLabelRegularfs16 mb-5">Gender <span class="red-cl">&nbsp;*</span></label>
                <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">

                  <mat-select placeholder="Select Gender" formControlName="genders">
                    <mat-option value="Male">Male</mat-option>
                    <mat-option value="Female">Female</mat-option>
                    <mat-option value="Cannot_Disclose">Don't wish to disclose</mat-option>

                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="hasError('genders', 'required')">gender name is required</mat-error>
              </ion-col>
            </ion-col>

            <!-- Country -->
            <ion-col size="12" size-md="3">
              <!-- <label class="formLabelRegularfs16 mb-5">Country <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Select Country" formControlName="country"    />
               
                <mat-error *ngIf="hasError('country', 'required')">country is
                  required</mat-error>
              </mat-form-field> -->
              <label class="formLabelRegularfs16 mb-5">Country <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Select Country" formControlName="country">
                  <mat-option *ngFor="let item of getCountryList" [value]="item.id">{{item.name}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error *ngIf="hasError('country', 'required')" class="mb-10">country is required</mat-error>

            </ion-col>

            <!-- Present Address -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Present Address <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Present Address" formControlName="presentAddress" />

              </mat-form-field>
              <mat-error *ngIf="hasError('presentAddress', 'required')" class="mb-10">present address is
                required</mat-error>
              <mat-error *ngIf="employeeForm.get('presentAddress')?.hasError('maxlength')">
                Maximum 255 characters allowed
              </mat-error>
            </ion-col>

            <!-- Permanent Address -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Permanent Address</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Permanent Address" formControlName="permanentAddress" />
                <mat-error *ngIf="employeeForm.get('permanentAddress')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <!-- <label class="formLabelRegularfs16 mb-5">Marital Satus</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Permanent Address" formControlName="maritalStatus"    />
              </mat-form-field> -->

              <label class="formLabelRegularfs16 mb-5">Marital Satus</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Select Marital Status" formControlName="maritalStatus">
                  <mat-option value="Single">Single</mat-option>
                  <mat-option value="Married">Married</mat-option>
                  <mat-option value="Divorced">Divorced</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error *ngIf="hasError('maritalStatus', 'required')" class="mb-10">marital status is
                required</mat-error>

            </ion-col>
            <!-- Date of Birth -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Date of Birth <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput [matDatepicker]="picker" placeholder="Select Date of Birth"
                  formControlName="dateOfBirth" (dateChange)="calculateAgeFromDOB()" [max]="today" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="hasError('dateOfBirth', 'required')">date of birth is
                  required</mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Age -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Age<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Age" formControlName="age" readonly />
                <mat-error *ngIf="hasError('age', 'required')">age is
                  required</mat-error>
              </mat-form-field>
            </ion-col>


            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Addhar Card No.<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter addhar no" formControlName="aadhaarCardNo"
                  (keypress)="handleInput($event, 'aadhaarCardNo')" (input)="checkAadharNo()" />
                <mat-error *ngIf="hasError('aadhaarCardNo', 'required')&& !showErrorMsgOfExistAddharNo">aadhaar card no
                  is
                  required</mat-error>
                <mat-error *ngIf="hasError('aadhaarCardNo', 'pattern') && !showErrorMsgOfExistAddharNo"> Aadhaar must be
                  exactly 12 digits.</mat-error>
              </mat-form-field>
              <!-- <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistAddharNo">AdharCard No. Already
                Exists</label> -->
              <mat-error *ngIf="employeeForm.get('aadhaarCardNo')?.hasError('existAadharNo')">
                This Aadhaar number already exists.
              </mat-error>
            </ion-col>
            <!-- PAN Number -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">PAN No. <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter PAN Number" formControlName="panNo"
                  (input)="handleInput($event, 'pan')" (input)="checkPanNo()" />
                <!-- <mat-error *ngIf="hasError('panNo', 'required')">pan no is
                  required</mat-error> -->
                <mat-error *ngIf="hasError('panNo', 'required') && !showErrorMsgOfExistPAN">
                  PAN number is required.
                </mat-error>

                <mat-error *ngIf="hasError('panNo', 'pattern') && !showErrorMsgOfExistPAN">
                  Enter a valid PAN number (e.g., ABCDE1234F).
                </mat-error>
              </mat-form-field>
              <mat-error *ngIf="employeeForm.get('panNo')?.hasError('existPAN')">
                This PAN number already exists.
              </mat-error>
              <!-- <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistPAN">Pan No.
                Already Exists</label> -->
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">UAN No.</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter UAN Number" formControlName="unaNo"
                  (keydown)="restrictCharacters($event, 'unaNo')" (input)="checkUanNo()" />
                <mat-error *ngIf="employeeForm.get('unaNo')?.hasError('pattern') &&!showErrorMsgOfExistUAN">
                  UAN must be exactly 12 digits.
                </mat-error>
              </mat-form-field>
              <!-- <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistUAN">UAN No. Already
                Exists</label> -->
              <mat-error *ngIf="employeeForm.get('unaNo')?.hasError('existUAN')">
                This UAN number already exists.
              </mat-error>

            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Mobile No. (Whats App No)<span
                  class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="number" matInput placeholder="Enter mobile Number" formControlName="mobileNo"
                  (keypress)="handleInput($event, 'mobileNo')" (input)="checkMobileNo()" />
                <mat-error *ngIf="hasError('mobileNo', 'required') && !showErrorMsgOfExistMobileNo">
                  mobile number is required.
                </mat-error>
                <mat-error *ngIf="hasError('mobileNo', 'pattern') && ! showErrorMsgOfExistMobileNo">
                  enter a valid contact number.
                </mat-error>
              </mat-form-field>
              <mat-error *ngIf="employeeForm.get('mobileNo')?.hasError('existMobileNo')">
                This mobile number already exists.
              </mat-error>

              <!-- <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistMobileNo">Mobile No. Already
                Exists</label> -->
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Total Previous Expe Before Joining</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="number" matInput placeholder="Enter Total Expe " formControlName="previousExperience" />
                <mat-error *ngIf="employeeForm.get('previousExperience')?.hasError('pattern')">
                  Invalid year of expe
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Emergency Contact Number<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="number" matInput placeholder="Enter Contact Number" formControlName="emergencyContact"
                  (keypress)="handleInput($event, 'emergencyContact')" />
              </mat-form-field>
                 <mat-error *ngIf="hasError('emergencyContact', 'required')">
                  Emergency contact number is required.
                </mat-error>
              <mat-error *ngIf="hasError('emergencyContact', 'pattern')">
                enter a valid contact number.
              </mat-error>
            </ion-col>
            <ion-col size="12" size-md="3">


              <!-- <label class="formLabelRegularfs16 mb-5">Blood Group</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                
                <input type="text" matInput placeholder="Select Boold Group" formControlName="bloodGroup"    />
              </mat-form-field> -->
              <label class="formLabelRegularfs16 mb-5">Blood Group<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select formControlName="bloodGroup" placeholder="Select Blood Group">
                  <mat-option *ngFor="let bloodGroup of bloodGroups" [value]="bloodGroup">
                    {{ bloodGroup }}
                  </mat-option>
                </mat-select>
                   <mat-error *ngIf="hasError('bloodGroup', 'required')">
                  Blood group is required.
                </mat-error>
              </mat-form-field>

            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Father's Name</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="text" matInput placeholder="Enter Father's Name" formControlName="fathersName" />
                <mat-error *ngIf="employeeForm.get('fathersName')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('fathersName')?.hasError('pattern') && !employeeForm.get('fathersName')?.hasError('maxlength')">
                  Only letters, spaces, and - allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Mother's Name</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="text" matInput placeholder="Enter Mother's Name" formControlName="mothersName" />
                <mat-error *ngIf="employeeForm.get('mothersName')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('mothersName')?.hasError('pattern')&& !employeeForm.get('mothersName')?.hasError('maxlength')">
                  Only letters, spaces, and - allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Spouse's Name</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="text" matInput placeholder="Enter Spouse's Name" formControlName="spouseName" />
                <mat-error *ngIf="employeeForm.get('spouseName')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error *ngIf="employeeForm.get('spouseName')?.hasError('pattern')">
                  Only letters, spaces, and - allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">No Of Children</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="number" matInput placeholder="No Of Children" formControlName="noOfChildren"
                  (keydown)="preventFloatInput($event)" (paste)="preventInvalidPaste($event)" />

                <mat-error *ngIf="employeeForm.get('noOfChildren')?.hasError('max')">
                  Maximum 20 children allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Is Relative Working?</label>
              <!-- <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="text" matInput placeholder="Enter Details" formControlName="relativeWorking" />
              </mat-form-field> -->
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Select Employment Category" formControlName="relativeWorking">
                  <mat-option [value]="'Yes'">
                    Yes
                  </mat-option>
                  <mat-option [value]="'No'">
                    No
                  </mat-option>
                </mat-select>

              </mat-form-field>
            </ion-col>
            <!-- Additional Fields Here -->
          </ion-row>
        </div>

      </div>

      <div class="cardBox mt-20">
        <div class="cardBoxHeading font_medium">
          <ion-row class="pl-5">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="font_bold ">Education Related Information</div>
            </ion-col>
          </ion-row>
        </div>

        <!-- <mat-expansion-panel-header>
                          <mat-panel-title>Education Related Information</mat-panel-title>
                        </mat-expansion-panel-header> -->
        <div class="font_medium ml-10 mr-10">
          <ion-row class="responsive-form m-10  p-20">
            <!-- Highest Education Qualification -->

            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Highest Education Qualification </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Highest Education Qualification"
                  formControlName="highestEducation" />
                <mat-error
                  *ngIf="employeeForm.get('highestEducation')?.hasError('maxlength')&& !employeeForm.get('highestEducation')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error *ngIf="employeeForm.get('highestEducation')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, ' and - allowed'

                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Highest Education Institute -->
            <ion-col size="12" size-md="3" class="mb-10">
              <label class="formLabelRegularfs16 mb-5">Highest Education Institute </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Highest Education Institute"
                  formControlName="highestEducationInstitute" />
                <mat-error
                  *ngIf="employeeForm.get('highestEducationInstitute')?.hasError('maxlength')&& !employeeForm.get('highestEducationInstitute')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error *ngIf="employeeForm.get('highestEducationInstitute')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, ' and - allowed'

                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Highest Education Year of Passing -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5"> Highest Education Year of Passing </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter Year of Passing" formControlName="highestEducationYear"
                  maxlength="4" inputmode="numeric" (keypress)="allowOnlyDigits($event)" />

                <mat-error
                  *ngIf="hasError('highestEducationYear', 'pattern')&& employeeForm.get('highestEducationYear')?.value">
                  Only 4 digits allowed.
                </mat-error>
                <mat-error
                  *ngIf="hasError('highestEducationYear', 'invalidYear')&& employeeForm.get('highestEducationYear')?.value">
                  Invalid year
                </mat-error>
              </mat-form-field>

            </ion-col>

            <!-- Highest Education Percentage/CGPA -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5"> Highest Education Marks/%ge </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" [min]="0" placeholder="Enter Marks/%ge "
                  formControlName="highestEducationMarks" (keydown)="preventNegativeValues($event)" />
                <mat-error
                  *ngIf="employeeForm.get('highestEducationMarks')?.hasError('pattern')&& employeeForm.get('highestEducationMarks')?.value">
                  Enter a valid number (e.g., 89.75)
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('highestEducationMarks')?.hasError('max') && !employeeForm.get('highestEducationMarks')?.hasError('pattern')">
                  Marks cannot exceed 100
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Second Highest Education Qualification -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">2nd Highest Education Qualification</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter 2nd Highest Education Qualification"
                  formControlName="secondEducation" />
                <mat-error
                  *ngIf="employeeForm.get('secondEducation')?.hasError('maxlength')&& !employeeForm.get('secondEducation')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error *ngIf="employeeForm.get('secondEducation')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, ' and - allowed

                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Second Highest Education Institute -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">2nd Highest Education Institute</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter 2nd Highest Education Institute"
                  formControlName="secondEducationInstitute" />
                <mat-error
                  *ngIf="employeeForm.get('secondEducationInstitute')?.hasError('maxlength')&& !employeeForm.get('secondEducationInstitute')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error *ngIf="employeeForm.get('secondEducationInstitute')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, ' and - allowed

                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Second Highest Education Year of Passing -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">2nd Highest Education Year of Passing</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter Year of Passing" formControlName="secondEducationYear"
                  maxlength="4" inputmode="numeric" (keypress)="allowOnlyDigits($event)" />
                <mat-error
                  *ngIf="hasError('secondEducationYear', 'pattern')&& employeeForm.get('secondEducationYear')?.value">
                  4 digit is required.
                </mat-error>
                <mat-error
                  *ngIf="hasError('secondEducationYear', 'invalidYear')&& employeeForm.get('secondEducationYear')?.value">
                  Invalid year
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Second Highest Education Percentage/CGPA -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">2nd Highest Education Marks/%ge </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Marks/%ge" formControlName="secondEducationMarks"
                  (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="employeeForm.get('secondEducationMarks')?.hasError('pattern')">
                  Enter a valid number (e.g., 89.75)
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('secondEducationMarks')?.hasError('max') && !employeeForm.get('secondEducationMarks')?.hasError('pattern')">
                  Marks cannot exceed 100
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Third Highest Education Qualification -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">3rd Highest Education Qualification</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter 3rd Highest Education Qualification"
                  formControlName="thirdEducation" />
                <mat-error
                  *ngIf="employeeForm.get('thirdEducation')?.hasError('maxlength') && !employeeForm.get('thirdEducation')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>

                <mat-error *ngIf="employeeForm.get('thirdEducation')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, ' and - allowed

                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Third Highest Education Institute -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">3rd Highest Education Institute</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter 3rd Highest Education Institute"
                  formControlName="thirdEducationInstitute" />
                <mat-error
                  *ngIf="employeeForm.get('thirdEducationInstitute')?.hasError('maxlength') && !employeeForm.get('thirdEducationInstitute')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>

                <mat-error *ngIf="employeeForm.get('thirdEducationInstitute')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, ' and - allowed

                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Third Highest Education Year of Passing -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">3rd Highest Education Year of Passing</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter Year of Passing" formControlName="thirdEducationYear"
                  maxlength="4" inputmode="numeric" (keypress)="allowOnlyDigits($event)" />
                <mat-error
                  *ngIf="hasError('thirdEducationYear', 'pattern')&& employeeForm.get('thirdEducationYear')?.value">
                  4 digit is required.
                </mat-error>
                <mat-error
                  *ngIf="hasError('thirdEducationYear', 'invalidYear')&&employeeForm.get('thirdEducationYear')?.value">
                  Invalid year
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Third Highest Education Percentage/CGPA -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">3rd Highest Education Marks/%ge </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Marks/%ge " formControlName="thirdEducationMarks"
                  (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="employeeForm.get('thirdEducationMarks')?.hasError('pattern')">
                  Enter a valid number (e.g., 89.75)
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('thirdEducationMarks')?.hasError('max') && !employeeForm.get('thirdEducationMarks')?.hasError('pattern')">
                  Marks cannot exceed 100
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Highest Professional Qualification -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Highest Professional Qualification</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Highest Professional Qualification"
                  formControlName="highestProfessional" />
                <mat-error
                  *ngIf="employeeForm.get('highestProfessional')?.hasError('maxlength') && !employeeForm.get('highestProfessional')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>

                <mat-error *ngIf="employeeForm.get('highestProfessional')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, ' and - allowed

                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Highest Professional Institute -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Highest Professional Institute</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Highest Professional Institute"
                  formControlName="highestProfessionalInstitute" />
                <mat-error
                  *ngIf="employeeForm.get('highestProfessionalInstitute')?.hasError('maxlength') && !employeeForm.get('highestProfessionalInstitute')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>

                <mat-error *ngIf="employeeForm.get('highestProfessionalInstitute')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, ' and - allowed

                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Highest Professional Year of Passing -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Highest Professional Year of Passing</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter Year of Passing"
                  formControlName="highestProfessionalYear" maxlength="4" inputmode="numeric"
                  (keypress)="allowOnlyDigits($event)" />
                <mat-error
                  *ngIf="hasError('highestProfessionalYear', 'pattern')&& employeeForm.get('highestProfessionalYear')?.value">
                  4 digit is required.
                </mat-error>
                <mat-error
                  *ngIf="hasError('highestProfessionalYear', 'invalidYear')&& employeeForm.get('highestProfessionalYear')?.value">
                  Invalid year
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Highest Professional Percentage/CGPA -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Highest Professional Marks/%ge </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Marks/%ge " formControlName="highestProfessionalMarks"
                  (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="employeeForm.get('highestProfessionalMarks')?.hasError('pattern')">
                  Enter a valid number (e.g., 89.75)
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('highestProfessionalMarks')?.hasError('max') && !employeeForm.get('highestProfessionalMarks')?.hasError('pattern')">
                  Marks cannot exceed 100
                </mat-error>

              </mat-form-field>
            </ion-col>
          </ion-row>
        </div>


      </div>

      <div class="cardBox mt-20 ">
        <div class="cardBoxHeading font_medium">
          <ion-row class="pl-5">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="font_bold ">Prior Employment Related Information</div>
            </ion-col>
          </ion-row>
        </div>



        <div class="font_medium ml-10 mr-10">
          <ion-row class=" p-20">
            <!-- Last Organisation Before Joining -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last Organisation Before Joining</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Last Organisation" [formControlName]="'lastOrganisation'" />
                <mat-error *ngIf="employeeForm.get('lastOrganisation')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('lastOrganisation')?.hasError('pattern') && !employeeForm.get('lastOrganisation')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last Organisation Date Of Joining</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput [matDatepicker]="joiningPicker" placeholder="Select Date Of Joining"
                  formControlName="lastOrganisationJoiningDate" [max]="today" readonly>
                <mat-datepicker-toggle matSuffix [for]="joiningPicker"></mat-datepicker-toggle>
                <mat-datepicker #joiningPicker></mat-datepicker>
              </mat-form-field>


            </ion-col>

            <!-- Last Organisation Last Working Date -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last Org Last Working Date</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput [matDatepicker]="lastWorkingPicker" placeholder="Select Last Working Date"
                  formControlName="lastOrganisationLastWorkingDate" [max]="today" readonly>
                <mat-datepicker-toggle matSuffix [for]="lastWorkingPicker"></mat-datepicker-toggle>
                <mat-datepicker #lastWorkingPicker></mat-datepicker>
              </mat-form-field>
            </ion-col>

            <!-- Last Organisation Department -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last Org Department</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Department" [formControlName]="'lastOrganisationDepartment'" />
                <mat-error *ngIf="employeeForm.get('lastOrganisationDepartment')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('lastOrganisationDepartment')?.hasError('pattern') && !employeeForm.get('lastOrganisationDepartment')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Last Organisation Designation -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last Org Designation</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Designation" [formControlName]="'lastOrganisationDesignation'" />
                <mat-error *ngIf="employeeForm.get('lastOrganisationDesignation')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('lastOrganisationDesignation')?.hasError('pattern') && !employeeForm.get('lastOrganisationDesignation')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Last to Last Organisation -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last to Last Org Before Joining</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Organisation" [formControlName]="'lastToLastOrganisation'" />
                <mat-error *ngIf="employeeForm.get('lastToLastOrganisation')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('lastToLastOrganisation')?.hasError('pattern') && !employeeForm.get('lastToLastOrganisation')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Last to Last Organisation Date Of Joining -->
            <!-- Last to Last Organisation Date Of Joining -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last to Last Org Date Of Joining</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput [matDatepicker]="lastToLastJoiningPicker" placeholder="Select Date Of Joining"
                  formControlName="lastToLastOrganisationJoiningDate" [max]="today" readonly>
                <mat-datepicker-toggle matSuffix [for]="lastToLastJoiningPicker"></mat-datepicker-toggle>
                <mat-datepicker #lastToLastJoiningPicker></mat-datepicker>
              </mat-form-field>
            </ion-col>

            <!-- Last to Last Organisation Last Working Date -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last to Last Org Last Working Date</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput [matDatepicker]="lastToLastWorkingPicker" placeholder="Select Last Working Date"
                  formControlName="lastToLastOrganisationLastWorkingDate" [max]="today" readonly>
                <mat-datepicker-toggle matSuffix [for]="lastToLastWorkingPicker"></mat-datepicker-toggle>
                <mat-datepicker #lastToLastWorkingPicker></mat-datepicker>
              </mat-form-field>
            </ion-col>


            <!-- Last to Last Organisation Department -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last to Last Org Department</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Department" [formControlName]="'lastToLastOrganisationDepartment'" />
                <mat-error *ngIf="employeeForm.get('lastToLastOrganisationDepartment')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('lastToLastOrganisationDepartment')?.hasError('pattern') && !employeeForm.get('lastToLastOrganisationDepartment')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Last to Last Organisation Designation -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last to Last Org Designation</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Designation"
                  [formControlName]="'lastToLastOrganisationDesignation'" />
                <mat-error *ngIf="employeeForm.get('lastToLastOrganisationDesignation')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('lastToLastOrganisationDesignation')?.hasError('pattern') && !employeeForm.get('lastToLastOrganisationDesignation')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Any Other Organisation Joined Before -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Any Other Org Joined Before</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Organisation" [formControlName]="'anyOtherOrganisation'" />
                <mat-error *ngIf="employeeForm.get('anyOtherOrganisation')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('anyOtherOrganisation')?.hasError('pattern') && !employeeForm.get('anyOtherOrganisation')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Any Other Organisation Date Of Joining -->
            <!-- Any Other Organisation Date Of Joining -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Any Other Org Date Of Joining</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput [matDatepicker]="anyOtherJoiningPicker" [max]="today"
                  placeholder="Select Date Of Joining" formControlName="anyOtherOrganisationJoiningDate" readonly>
                <mat-datepicker-toggle matSuffix [for]="anyOtherJoiningPicker"></mat-datepicker-toggle>
                <mat-datepicker #anyOtherJoiningPicker></mat-datepicker>
              </mat-form-field>
            </ion-col>

            <!-- Any Other Organisation Last Working Date -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Any Other Org Last Working Date</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput [matDatepicker]="anyOtherLastWorkingPicker" placeholder="Select Last Working Date"
                  formControlName="anyOtherOrganisationLastWorkingDate" [max]="today" readonly>
                <mat-datepicker-toggle matSuffix [for]="anyOtherLastWorkingPicker"></mat-datepicker-toggle>
                <mat-datepicker #anyOtherLastWorkingPicker></mat-datepicker>
              </mat-form-field>
            </ion-col>


            <!-- Any Other Organisation Department -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Any Other Org Department</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Department" [formControlName]="'anyOtherOrganisationDepartment'" />
                <mat-error *ngIf="employeeForm.get('anyOtherOrganisationDepartment')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('anyOtherOrganisationDepartment')?.hasError('pattern') && !employeeForm.get('anyOtherOrganisationDepartment')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>

            <!-- Any Other Organisation Designation -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Any Other Org Designation</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput placeholder="Enter Designation" [formControlName]="'anyOtherOrganisationDesignation'" />
                <mat-error *ngIf="employeeForm.get('anyOtherOrganisationDesignation')?.hasError('maxlength')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error
                  *ngIf="employeeForm.get('anyOtherOrganisationDesignation')?.hasError('pattern') && !employeeForm.get('anyOtherOrganisationDesignation')?.hasError('maxlength')">
                  Only A-Z, 0-9, space, dot, ' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>
          </ion-row>
        </div>

      </div>
      <div class=" mt-20">

        <h5 style="color:#f59737;">TO BE FILLED BY HR ADMIN</h5>
      </div>
      <div class="cardBox mt-20">
        <div class="cardBoxHeading font_medium">
          <ion-row class="pl-5">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="font_bold">Current Employment Related Information</div>
            </ion-col>
          </ion-row>
        </div>
        <div class="font_medium ml-10 mr-10">
          <ion-row class="responsive-form m-10 p-20">
            <!-- Employment Category -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Employment Category <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Select Employment Category" [(value)]="selectedCategory"
                  formControlName="employmentCategory">
                  <mat-option *ngFor="let category of employmentCategories" [value]="category">
                    {{ category }}
                  </mat-option>

                </mat-select>
                <mat-error *ngIf="hasError('employmentCategory', 'required') ">employment category is
                  required</mat-error>
              </mat-form-field>
            </ion-col>


            <!-- Employment Type -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Employment Type <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10 mb-5">
                <mat-select placeholder="Select Employment Type" [(value)]="selectedEmploymentType"
                  formControlName="employmentType">
                  <mat-option *ngFor="let type of employmentTypes" [value]="type">
                    {{ type }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="hasError('employmentType', 'required')">employment type is required</mat-error>
              </mat-form-field>
            </ion-col>


            <!-- Retirement Age -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Retirement Age</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Age" formControlName="retirementAge" />

                <mat-error *ngIf="employeeForm.get('retirementAge')?.hasError('max')">
                  Maximum age allowed is 100
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Employee Status -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Employee Status <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">


                <!-- <mat-select placeholder="Select Employment Status" [(value)]="selectedEmploymentstatus"
                  formControlName="empStatus">
                  <mat-option *ngFor="let status of employmentstatus" [value]="status">
                    {{ status }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="hasError('empStatus', 'required')">emp status is required</mat-error> -->
                <input matInput type="text" placeholder="Enter status" formControlName="empStatus" readonly />
                <mat-error *ngIf="hasError('empStatus', 'required')">emp status is required</mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Date of Joining -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Date of Joining <span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput [matDatepicker]="picker1" placeholder="DD/MM/YYYY" formControlName="dateOfJoining"
                  readonly />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error *ngIf="hasError('dateOfJoining', 'required')">date of joining is required</mat-error>

              </mat-form-field>
            </ion-col>



            <!-- Group Name -->

            <!-- 
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Group Name<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Type here" formControlName="groupName" />
                <mat-error *ngIf="hasError('groupName', 'required')">group name is required</mat-error>

              </mat-form-field>
            </ion-col> -->
            <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
              <div class="formLabelRegularfs14 mb-5">Group Name<span class="red-cl">&nbsp;*</span></div>
              <ng-select [addTag]="true" placeholder="Select Group Name" formControlName="groupName" [clearable]="employeeForm.get('groupName')?.value ? true : false">
                <ng-option [value]="item.id" *ngFor="let item of getListOfGroupNameOfComp">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('groupName', 'required')">group name is required</mat-error>
              <label *ngIf="!hasError('groupName', 'required') && isCompanyNameTooLong('groupName')"
                class="error-label">
                Maximum 255 characters allowed
              </label>
            </ion-col>
            <!-- Company Name -->
            <!-- <ion-col size="12" size-md="3">
                <label class="formLabelRegularfs16 mb-5">Company Name <span class="red-cl">&nbsp;*</span></label>
                <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                  <input matInput type="text" placeholder="Type here" formControlName="companyName" />
                  <mat-error *ngIf="hasError('companyName', 'required')">companyName is required</mat-error>
              
                </mat-form-field>
              </ion-col> -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">
                Company Name<span class="red-cl">&nbsp;*</span>
              </div>

              <ng-select [addTag]="true" [clearable]="employeeForm.get('companyName')?.value ? true : false" placeholder="Select Company Name" formControlName="companyName">
                <ng-option [value]="item.id" *ngFor="let item of getListOfCompanyNameOfComp">
                  {{ item.name }}
                </ng-option>
              </ng-select>

              <mat-error *ngIf="hasError('companyName', 'required')">
                Company name is required
              </mat-error>

              <label *ngIf="!hasError('companyName', 'required') && isCompanyNameTooLong('companyName')"
                class="error-label">
                Maximum 255 characters allowed
              </label>

            </ion-col>

            <!-- Reporting Manager Name -->

            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">Reporting Manager Name<span class="red-cl">&nbsp;*</span></div>
              <ng-select [clearable]="false" placeholder="Select Manager Name" formControlName="reportingManagerName"
                (change)="onSelectionOfManager()">
                <ng-option [value]="item.id" *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('reportingManagerName', 'required')">reporting Manager name is
                required</mat-error>
            </ion-col>

            <!-- Reporting Manager Code -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Reporting Manager Code<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Type here" formControlName="reportingManagerCode" readonly />
                <mat-error *ngIf="hasError('reportingManagerCode', 'required')">reporting manager code is
                  required</mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Dotted Reporting Manager Name -->
            <!-- <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Dotted Reporting Manager Name<span
                  class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Type here" formControlName="dottedReportingManagerName" />
              </mat-form-field>
            </ion-col> -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">Dotted Reporting Manager Name
              </div>
              <ng-select placeholder="Select Dotted Reporting Manager Name" formControlName="dottedReportingManagerName"
                (change)="onSelectionOfDottedManager()">
                <ng-option [value]="item.id" *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
              </ng-select>

            </ion-col>
            <!-- Dotted Reporting Manager Code -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Dotted Reporting Manager Code</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Dotted Reporting" formControlName="dottedReportingManagerCode"
                  readonly />
              </mat-form-field>
            </ion-col>

            <!-- HOD Name -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">HOD Name<span class="red-cl">&nbsp;*</span></div>
              <ng-select [clearable]="false" placeholder="Select HOD Name" formControlName="hodName"
                (change)="onSelectionOfHod()">
                <ng-option [value]="item.id" *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('hodName', 'required')">hod name is required</mat-error>

            </ion-col>

            <!-- HOD Code -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">HOD Code<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Hod populated" formControlName="hodCode" readonly />
                <mat-error *ngIf="hasError('hodCode', 'required')">hod code is required</mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Band -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">Band<span class="red-cl">&nbsp;*</span></div>
              <ng-select [addTag]="true"[clearable]="employeeForm.get('band')?.value ? true : false" placeholder="Select Band" formControlName="band"
                (change)="onBandChange($event)">
                <ng-option [value]="item.id" *ngFor="let item of getListOfBandNameOfComp">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('band', 'required')">band is required</mat-error>
              <label *ngIf="!hasError('band', 'required') && isCompanyNameTooLong('band')" class="error-label">
                Maximum 255 characters allowed
              </label>
            </ion-col>

            <!-- Grade -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">Grade<span class="red-cl">&nbsp;*</span></div>
              <ng-select [addTag]="true" [clearable]="employeeForm.get('grade')?.value ? true : false"placeholder="Select Grade" formControlName="grade">
                <ng-option [value]="item.id" *ngFor="let item of getListOfGradeNameOfComp">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('grade', 'required')">grade
                is required</mat-error>
              <label *ngIf="!hasError('grade', 'required') && isCompanyNameTooLong('grade')" class="error-label">
                Maximum 255 characters allowed
              </label>
            </ion-col>

            <!-- Designation -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">Designation<span class="red-cl">&nbsp;*</span></div>
              <ng-select [addTag]="true"[clearable]="employeeForm.get('designation')?.value ? true : false" placeholder="Select Designation" formControlName="designation">
                <ng-option [value]="item.id" *ngFor="let item of getListOfDesignationsOfComp">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('designation', 'required')">designation is required</mat-error>
              <label *ngIf="!hasError('designation', 'required') && isCompanyNameTooLong('designation')"
                class="error-label">
                Maximum 255 characters allowed
              </label>
            </ion-col>
            <!-- 

            
              <ion-col size="12" size-md="3">
                <div  class="formLabelRegularfs16 mb-5">Department/Function<span 
                    class="red-cl">&nbsp;*</span>
                </div>
                <ng-select [addTag]="true" placeholder="Select Department/Function" formControlName="department"(change)="addDeptAndLoc('addDept')">
                  <ng-option [value]="item.id"
                    *ngFor="let item of getListOfDepartmentsOfComp" >{{item.name}}</ng-option>
                </ng-select>
                <mat-error *ngIf="hasError('department', 'required')">department is required</mat-error>
              </ion-col> -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">
                Department/Function<span class="red-cl">&nbsp;*</span>
              </div>

              <ng-select [addTag]="true"[clearable]="employeeForm.get('department')?.value ? true : false" placeholder="Select Department/Function" formControlName="department"
                (change)="onDepartmentChange($event)" [clearable]="employeeForm.get('department')?.value ? true : false">

                <ng-option *ngFor="let item of this.CombineDeptArray" [value]="item.department">
                  {{ item.department }}
                </ng-option>

              </ng-select>

              <mat-error *ngIf="hasError('department', 'required')">
                department is required
              </mat-error>
              <label *ngIf="!hasError('department', 'required') && isCompanyNameTooLong('department')"
                class="error-label">
                Maximum 255 characters allowed
              </label>
            </ion-col>


            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">Sub Department/Sub Function</div>
              <!-- <ng-select placeholder="Select Sub Department/Sub Function"
                  formControlName="subDepartment">
                  <mat-error *ngIf="hasError('subDepartment', 'required')"> sub department is required</mat-error>
                </ng-select> -->
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput type="text" placeholder="Hod populated" formControlName="subDepartment" />
                <mat-error
                  *ngIf="employeeForm.get('subDepartment')?.hasError('maxlength') && !employeeForm.get('subDepartment')?.hasError('pattern')">
                  Maximum 255 characters allowed
                </mat-error>
                <mat-error *ngIf="employeeForm.get('subDepartment')?.hasError('pattern')">
                  Only A-Z, 0-9, space, dot, comma,' and - allowed
                </mat-error>

              </mat-form-field>
            </ion-col>
            <!-- Work Location - State -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">Work Location-State<span class="red-cl">&nbsp;*</span></div>
              <ng-select dropdownPosition="top" placeholder="Select Work Location-State"
                formControlName="workLocationState" [clearable]="employeeForm.get('workLocationState')?.value ? true : false">
                <ng-option [value]="item" *ngFor="let item of states">{{item}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('workLocationState', 'required')">work location state is required</mat-error>
              <label *ngIf="!hasError('workLocationState', 'required') && isCompanyNameTooLong('workLocationState')"
                class="error-label">
                Maximum 255 characters allowed
              </label>
            </ion-col>

            <!-- Work Location - City/Town -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Work Location- City/Town<span
                  class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter Work Location-City/Town"
                  formControlName="workLocationCity" />
                <mat-error *ngIf="hasError('workLocationCity', 'required')">work location city is required</mat-error>
                <mat-error
                  *ngIf="employeeForm.get('workLocationCity')?.hasError('maxlength') && !hasError('workLocationCity', 'required')">
                  Maximum 255 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Designation At DOJ -->
            <ion-col size="12" size-md="3">
              <div class="formLabelRegularfs16 mb-5">Designation at DOJ<span class="red-cl">&nbsp;*</span></div>
              <ng-select dropdownPosition="top" [addTag]="true" [clearable]="employeeForm.get('designationAtDoj')?.value ? true : false" placeholder="Select Designation at DOJ"
                formControlName="designationAtDoj">
                <ng-option [value]="item.id"
                  *ngFor="let item of getListOfDesignationsAtDOJOfComp">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('designationAtDoj', 'required')"> designationat doj is required</mat-error>
              <label *ngIf="!hasError('designationAtDoj', 'required') && isCompanyNameTooLong('designationAtDoj')"
                class="error-label">
                Maximum 255 characters allowed
              </label>
            </ion-col>

            <!-- No. of Promotion/Upgrades -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">No. of Promotion/Upgrades</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter No. of Promotion/Upgrades"
                  formControlName="noOfPromotions" [max]="100" (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="hasError('noOfPromotions','max')">
                  Maximum value is 100
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Current Individual PerfoScore -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Current Individual Perfo Score</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Current Individual Perf Score"
                  formControlName="currentPerformanceScore" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Current Individual PerfoRating -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Current Individual Perfo Rating</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style  mt-10">
                <input matInput type="number" placeholder="Type number here" class="font_regular"
                  formControlName="currentPerformanceRating" (keydown)="preventNegativeValues($event)">
              </mat-form-field>

            </ion-col>

            <!-- Last Year Individual PerfoScore -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last Year Individual PerfoScore</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Last Year Individual Perf Score"
                  formControlName="lastYearPerformanceScore" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Last Year Individual PerfoRating -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Last Year Individual PerfoRating</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Select" formControlName="lastYearPerformanceRating">
                  <mat-option *ngFor="let rating of ratingList" [value]="rating">
                    {{ rating }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>

            <!-- Year Before Last Year Individual PerfoScore -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Year Before Last Year Individual PerfoScore</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="number" matInput placeholder="Enter Year Before Last .."
                  formControlName="yearBeforeLastYearPerformanceScore" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Year Before Last Year Individual PerfoRating -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Year Before Last Year Individual PerfoRating</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">

                <input type="number" matInput placeholder="Type number here"
                  formControlName="yearBeforeLastYearPerformanceRating" (keydown)="preventNegativeValues($event)" />

              </mat-form-field>
            </ion-col>

          </ion-row>
        </div>
      </div>

      <div class="cardBox mt-20">
        <div class="cardBoxHeading font_medium">
          <ion-row class="pl-5">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="font_bold">Salary Related </div>
            </ion-col>
          </ion-row>
        </div>
        <div class="font_medium ml-10 mr-10">
          <ion-row class="responsive-form m-10 p-20">
            <!-- Employment Category -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Currency</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Enter Currency
                " formControlName="currency">
                  <mat-option *ngFor="let currency of currencyList" [value]="currency.value">
                    {{ currency.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>

            <!-- Salary Satus -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Salary Status<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Select Salary Status" [(value)]="selectedSalaryStatus"
                  formControlName="salaryStatus">
                  <mat-option *ngFor="let status of salaryStatuses" [value]="status">
                    {{ status }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="hasError('salaryStatus', 'required')"> salary status is required</mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Bank Name -->
            <!-- <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Bank Name<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter Bank Name" formControlName="bankName" />
                <mat-error *ngIf="hasError('bankName', 'required')"> bank name is required</mat-error>
              </mat-form-field>
            </ion-col> -->
            <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
              <div class="formLabelRegularfs14 mb-5">Bank Name<span class="red-cl">&nbsp;*</span></div>
              <ng-select dropdownPosition="bottom" [addTag]="true" placeholder="Select Bank Name"
                formControlName="bankName">
                <ng-option [value]="item.id" *ngFor="let item of getBankNameList">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('bankName', 'required')"> bank name is required</mat-error>

              <label *ngIf="!hasError('bankName', 'required') && isCompanyNameTooLong('bankName')" class="error-label">
                Maximum 255 characters allowed
              </label>
            </ion-col>
            <!-- Bank Branch Address-->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Bank Branch Address<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter Banck Branch Address"
                  formControlName="bankBranchAddress" />
                <mat-error *ngIf="hasError('bankBranchAddress', 'required')"> bank branch address is
                  required</mat-error>
                <mat-error
                  *ngIf="!hasError('bankBranchAddress', 'required') && employeeForm.get('bankBranchAddress')?.hasError('maxlength')">
                  Maximum 255 characters allowed.
                </mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Bank Account No.-->
            <!-- <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Bank Account No.<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Type here" formControlName="bankAccount" />
                <mat-error *ngIf="hasError('bankAccount', 'required')">bank account is required</mat-error>
              </mat-form-field>
            </ion-col> -->
            <!-- <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Bank Account No.<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Type here" formControlName="bankAccount"/>
                <mat-error *ngIf="hasError('bankAccount', 'required')">bank account is required</mat-error>

              </mat-form-field>
            </ion-col> -->

            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">
                Bank Account No.<span class="red-cl">&nbsp;*</span>
              </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Bank Account NO" formControlName="bankAccount"
                  (keydown)="preventNegativeValues($event)" (input)="checkAccountNo()" />
                <mat-error
                  *ngIf="employeeForm.get('bankAccount').hasError('required') && !showErrorMsgOfExistAccountNo">
                  Bank account is required!
                </mat-error>
                <mat-error *ngIf="employeeForm.get('bankAccount')?.hasError('existAccountNo')">
                  This bank account number already exists.
                </mat-error>
                <mat-error
                  *ngIf="!employeeForm.get('bankAccount')?.hasError('existAccountNo') && employeeForm.get('bankAccount')?.hasError('pattern')">
                  Enter a valid account number (9-18 digits).
                </mat-error>
              </mat-form-field>
              <!-- <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistAccountNo">Bank Account No.
                Already Exists</label> -->
            </ion-col>



            <!-- IFSC Code -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">IFSC Code<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="text" placeholder="Enter IFSC Code" formControlName="ifscCode" />
                <!-- <mat-error *ngIf="hasError('ifscCode', 'required')"> ifsc code is required</mat-error>
                <mat-error *ngIf="hasError('ifscCode', 'pattern')">
                  Enter a valid IFSC code (e.g., SBIN0001234).
                </mat-error> -->
                <mat-error *ngIf="hasError('ifscCode', 'required')">
                  ifsc code is required
                </mat-error>
                <mat-error *ngIf="!hasError('ifscCode', 'required')&&employeeForm.get('ifscCode')?.hasError('pattern')">
                  Enter a valid IFSC code .
                </mat-error>

              </mat-form-field>
            </ion-col>
            <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
              <div class="formLabelRegularfs14 mb-5">
                Effective Date<span class="red-cl">&nbsp;*</span>
              </div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input readonly matInput [matDatepicker]="effectiveDate" formControlName="effectiveDate"
                  placeholder="DD/MM/YYYY">
                <mat-datepicker-toggle matIconSuffix [for]="effectiveDate"></mat-datepicker-toggle>
                <mat-datepicker #effectiveDate></mat-datepicker>
  <mat-error *ngIf="hasError('effectiveDate', 'required')">
                 Effective date is required
                </mat-error>
              </mat-form-field>
            </ion-col>
            <!-- Basic Salaey PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Basic Salary PM<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Basic Salary" formControlName="basicSalaryPm"
                  (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="hasError('basicSalaryPm', 'required')"> basic salary pm is required</mat-error>
              </mat-form-field>
            </ion-col>

            <!-- Dearness Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Dearness Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder=" Enter Dearness Allowance PM" formControlName="daPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- HRM PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">HRA PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter HRA PM" formControlName="hraPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Other Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Other Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder=" Enter Other Allowance PM" formControlName="otherAllowancePm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- LTA PM-->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">LTA PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder=" Enter LTA PM" formControlName="ltaPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Medical Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Medical Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Medical Allowance P"
                  formControlName="medicalAllowancePm" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Washing Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Washing Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Washing Allowance PM"
                  formControlName="washingAllowancePm" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>


            <!-- Special Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Special Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Special Allowance PM"
                  formControlName="specialAllowancePm" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Fuel/Petrol Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Fuel/Petrol Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Fuel/Petrol Allowance PM"
                  formControlName="fuelAllowancePm" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Entertainment Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Entertainment Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Entertainment Allowance PM"
                  formControlName="entertainmentAllowancePm" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Education Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Education Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Education Allowance PM"
                  formControlName="educationAllowancePm" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <!-- Education Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Book and Periodical Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder=" Enter Book Allowance PM" formControlName="booksAllowancePm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>
            <!-- Education Allowance PM -->
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Statutory Bonus Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Statutory Bonus Allowance PM"
                  formControlName="statutoryBonusPm" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Any Other Allowance PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enetr Any Other Allowance PM"
                  formControlName="anyOtherAllowancePm" (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Gross Salary PM<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" [min]="0" placeholder="Enetr Gross Salary PM"
                  formControlName="grossSalaryPm" (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="hasError('grossSalaryPm', 'required')">
                  gross salary pm is required
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Employee PF PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Employee PF PM" formControlName="employeePfPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Employer PF PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Employer PF PM" formControlName="employerPfPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">PT PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter PT PM" formControlName="ptPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">LWF PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enetr LWF PM" formControlName="lwfPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">ESIC PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enetr ESIC PM" formControlName="esicPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Any Other Retrial PM</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Any Other Retrial PM" formControlName="otherRetiralPm"
                  (keydown)="preventNegativeValues($event)" />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Total Retrial PM<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enetr Total Retrial PM" formControlName="totalRetiralPm"
                  (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="hasError('totalRetiralPm', 'required')">total retiral pm is required</mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Fixed CTC Including Retrial PM<span
                  class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Fixed CTC Retrial PM"
                  formControlName="totalCTCIncludingRetiralPM" (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="hasError('totalCTCIncludingRetiralPM', 'required')">total CTC including retiral pm is
                  required</mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Fixed CTC Including Retrial PA<span
                  class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Fixed CTC Retrial PA"
                  formControlName="totalCTCIncludingRetiralPA" (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="hasError('totalCTCIncludingRetiralPA', 'required')">total CTC including retiral pa is
                  required</mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Process of Giving VP<span class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Select Process" [(value)]="selectedVPProcess" formControlName="processOfVp">
                  <mat-option *ngFor="let process of vpProcesses" [value]="process.id">

                    {{ process.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="hasError('processOfVp', 'required')">process of vp is required</mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Annual Variable Pay Budget</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Annual Variable Pay Budget"
                  formControlName="annualVariablePayBudget" (keydown)="preventNegativeValues($event)" />

              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Annual Total CTC(fixed CTC+annual variable pay budget)<span
                  class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input matInput type="number" placeholder="Enter Annual Total CTC" formControlName="annualTotalCtc"
                  (keydown)="preventNegativeValues($event)" />
                <mat-error *ngIf="hasError('annualTotalCtc', 'required')">annual total ctc is required</mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Increment on Fixed Annual CTC or Total Annual CTC<span
                  class="red-cl">&nbsp;*</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="Select Increment Type" [(value)]="selectedIncrementOn"
                  formControlName="incrementOn">
                  <mat-option *ngFor="let incrementType of incrementOnOptions" [value]="incrementType">

                    {{ formatedataVariable(incrementType) }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="hasError('incrementOn', 'required')">increment on is required</mat-error>
              </mat-form-field>
            </ion-col>

          </ion-row>
        </div>
      </div>
    </form>
    <div class="cardBox mt-20">
      <div class="cardBoxHeading font_medium">
        <ion-row class="pl-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="font_bold">Additional Field</div>
          </ion-col>
        </ion-row>
      </div>
      <div class="font_medium ml-10 mr-10">

        <!-- <ion-row class="responsive-form m-10 p-20">
        
            <ion-col size="12" size-md="3">
              <label class="formLabelRegularfs16 mb-5">Additional Field</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <mat-select placeholder="type here"></mat-select>
              </mat-form-field>
            </ion-col>
          </ion-row> -->

        <div class="p-10" slot="content">

          <ion-row>
            <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
              *ngFor="let item of customFieldData;let i = index">
              <div class="formLabelRegularfs14 mb-5">{{item.fieldName}}</div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input type="number" matInput placeholder="Enter number" class="font_regular"
                  [(ngModel)]="item.fieldValue" name="field{{i}}" (keydown)="preventNegativeValues($event)">
              </mat-form-field>
            </ion-col>
          </ion-row>
        </div>
        <ion-row>
          <ion-col size="12" class="text-right mt-10">

            <button (click)="closeDialog()" class="back_btn fs-14 fs_12ForMobile">Cancel</button>
            <button type="button" class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="buttonColorName"
              (click)="candidateGeneralAndSalaryinfowithoutgeneralinfo?updateAllFrom():SaveCurrentemployeerelatedInfo()">

              {{candidateGeneralAndSalaryinfowithoutgeneralinfo?'Update':'Save'}}

            </button>
            <!-- <button type="button" class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="buttonColorName"
              [disabled]="(employeeForm.invalid || showErrorMsgOfExistAccountNo || showErrorMsgOfExistAddharNo || showErrorMsgOfExistPAN || showErrorMsgOfExistUAN )" [ngStyle]="{
    opacity: (employeeForm.invalid || showErrorMsgOfExistAccountNo || showErrorMsgOfExistAddharNo || showErrorMsgOfExistPAN || showErrorMsgOfExistUAN ) ? 0.6 : 1,
    cursor: (employeeForm.invalid || showErrorMsgOfExistAccountNo || showErrorMsgOfExistAddharNo || showErrorMsgOfExistPAN || showErrorMsgOfExistUAN ) ? 'not-allowed' : 'pointer'
  }" (click)="candidateGeneralAndSalaryinfowithoutgeneralinfo ? updateAllFrom() : SaveCurrentemployeerelatedInfo()">
              {{ candidateGeneralAndSalaryinfowithoutgeneralinfo ? 'Update' : 'Save' }}
            </button> -->

          </ion-col>
        </ion-row>
      </div>
    </div>


  </div>


</mat-dialog-content>